import { styled } from 'linaria/react';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: var(--space-200);
`;
